import Swiper, { Pagination, Navigation, A11y, Lazy, Grid } from 'swiper';

import './_common.js';
import '../css/homepage.scss';
import { setupWidgetOnline } from './ui-part/widget-online.js';
import { getSearchAutocompletion } from './_search-autocompletion.js';
import './ui-part/user-template.js';

function setupTopicSearchAutocompletion()
{
    let input = document.querySelector('.hero-header-form-topic .enhanced-input-control');
    let hiddenInput = document.querySelector('.hero-header-form-topic .hero-header-form-topic-bare-id');
    let toggleButton = document.querySelector('.hero-header-form-topic .enhanced-input-dropdown-btn');

    if (!input || !hiddenInput || !toggleButton) {
        return;
    }

    let topics = JSON.parse(input.dataset.topics);

    getSearchAutocompletion(input, toggleButton, Object.values(topics));

    let updateHiddenInputFunc = () => {
        let item = Object.entries(topics).find(item => {
            return item[1] === input.value;
        });

        hiddenInput.value = item ? item[0] : '';
    };
    input.addEventListener('input', updateHiddenInputFunc);
    input.addEventListener('awesomplete-selectcomplete', updateHiddenInputFunc);
}

let googleMapsDeployed = false;
function deployGoogleMaps() {
    if (!window.app.googleMapsApiUrl) {
        return;
    }

    const googleMapsScriptSrc = document.createElement('script');
    googleMapsScriptSrc.setAttribute('src',window.app.googleMapsApiUrl);
    document.head.appendChild(googleMapsScriptSrc);
    googleMapsDeployed = true;
}

function setupCitySearchAutocompletion()
{
    let input = document.querySelector('.homepage-form-city .enhanced-input-control');
    let toggleButton = document.querySelector('.homepage-form-city .enhanced-input-dropdown-btn');
    let defaultCities = JSON.parse(input.dataset.cities);

    let autocompletion = getSearchAutocompletion(input, toggleButton, defaultCities);

    let googleAutocompleteService = null;
    let googleAutocompleteSettings = {
        types: ['(cities)'],
        componentRestrictions: { country: 'pl' },
    };

    autocompletion.filter = () => { return true; };
    autocompletion.sort = false;

    input.addEventListener('focus', () => {
        if (!googleMapsDeployed) {
            deployGoogleMaps();
        }
    });

    input.addEventListener('input', () => {
        if (!googleMapsDeployed) {
            deployGoogleMaps();
            return;
        }
        if (!googleAutocompleteService) {
            googleAutocompleteService = new google.maps.places.AutocompleteService();
        }
        let typedText = input.value;

        if (!typedText) {
            autocompletion.list = defaultCities;
            autocompletion.evaluate();

            return;
        }

        googleAutocompleteService.getPlacePredictions(
            { input: typedText, ...googleAutocompleteSettings },
            (predictions, status) => {
                autocompletion.list = [];

                if (status != google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
                    autocompletion.list = predictions.map(prediction => {
                        return prediction.structured_formatting.main_text;
                    });
                }

                autocompletion.evaluate();
            }
        );
    });
}

function setupSearchForm()
{
    const routes = window.app.routes;

    let topicInput = document.querySelector('.hero-header-form-topic .hero-header-form-topic-bare-id');
    let cityInput = document.querySelector('.homepage-form-city .enhanced-input-control');
    let form = document.querySelector('.hero-header-form');

    form.addEventListener('submit', event => {
        event.preventDefault();

        let city = cityInput.value;
        let topic = topicInput ? topicInput.value : '';

        if (!city && !topic) {
            return;
        }

        let url = routes.BASE_URL + '/';

        if (city) {
            url += routes.SEARCH_RESULTS_PREFIX + '/' + city;
        } else {
            url += routes.EXPERTS_ONLINE;
        }

        if (topic) {
            url += '?topic=' + topic;
        }

        window.location.href = url;
    });
}

function setupFeaturedUsersSlider()
{
    new Swiper('.featured-users-slider', {
        speed: 500,
        modules: [Pagination, Navigation, A11y, Lazy, Grid],

        preloadImages: false,
        slidesPerView: 2,
        slidesPerGroup: 2,
        watchSlidesProgress: true,
        lazy: {
            loadPrevNextAmount: 8, // bug - type max tiles count from breakpoints
            loadPrevNext: true,
        },
        grid: {
            rows: 2,
            fill: 'row'
        },
        breakpoints: {
            450: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            768: {
                slidesPerView: 4,
                slidesPerGroup: 4,
            },
        },

        navigation: {
            nextEl: '.featured-users-slider-button-next',
            prevEl: '.featured-users-slider-button-prev',
        },
        pagination: {
            el: '.featured-users-slider-pagination',
            type: 'bullets',
            clickable: true,
        },
        a11y: {
            notificationClass: 'sr-only',
        },

        on: {
            init: () => {
                document.querySelector('.featured-users').classList.remove('invisible');
            },
        },
    });

    document.querySelectorAll('.featured-users-slider-button').forEach(element => {
        element.addEventListener('click', () => { element.blur(); });
    });
}

function setupHomepageSectionsSlider() {
    document.querySelectorAll('.library-v2-slider').forEach(container => {
        new Swiper(container.querySelector('.library-v2-slider-container'), {
            speed: 500,
            modules: [Pagination, Navigation, A11y, Lazy, Grid],
            spaceBetween: 15,
            slidesPerView: 1,
            slidesPerGroup: 1,
            preloadImages: false,
            lazy: {
                checkInView: true,
                loadPrevNext: true,
                loadPrevNextAmount: 2,
                enabled: true
            },
            watchSlidesProgress: true,

            navigation: {
                nextEl: container.querySelector('.library-v2-slider-button.next'),
                prevEl: container.querySelector('.library-v2-slider-button.prev'),
            },
            grid: {
                rows: 2,
                fill: 'row'
            },
            a11y: {
                notificationClass: 'sr-only',
            },
            watchOverflow: true,
            slidesPerColumnFill: 'row',
            centerInsufficientSlides: true,

            breakpoints: {
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    grid: {
                        rows: 2
                    },
                },
                992: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    grid: {
                        rows: 2
                    },
                },
            },
            on: {
                init: () => {
                    container.classList.remove('invisible');
                },
            },
        });
    })
}

document.addEventListener('DOMContentLoaded', () => {
    setupTopicSearchAutocompletion();
    setupCitySearchAutocompletion();
    setupSearchForm();
    setupFeaturedUsersSlider();
    setupHomepageSectionsSlider();
    setupWidgetOnline();
});
